// extracted by mini-css-extract-plugin
export default {"container":"r4uTYI","divider":"PF83bC"};